import r from "./ghl-ui.es1473.js";
import o from "./ghl-ui.es1423.js";
function a(e) {
  o(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || r(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
export {
  a as default
};
